// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/produkte/wellenfederturm-fuer-thermomanagementsystem/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const produkteWellenfederturmFuerThermomanagementsystemDE: PageEntry = {
  id: "example.produkte-wellenfederturm-fuer-thermomanagementsystem",
  locale: "de",
  slug: "produkte/wellenfederturm-fuer-thermomanagementsystem",
  seo: {
    title: "Wellenfederturm für Thermomanagementsystem | Dietz GmbH",
    description: "Fertigung mit Sonderwerkzeugen und Kameraüberwachung für höchste Genauigkeit",
  },
  type: "post",
  h1: "Wellenfederturm für Thermomanagementsystem",
  intro: "Fertigung mit Sonderwerkzeugen und Kameraüberwachung für höchste Genauigkeit",
  blocks: [
    { kind: "image", src: "/images/live/wellenfederturm.jpg", alt: "Wellenfederturm", width: 1400, height: 1120 }
  ],
};
